import api from '@/services/api.ts'

type Props = {
  onboardingQuestions?: {
    question: string
    answer: string
  }[]
  isStudentDataInvalid?: boolean
}

const saveOnboardingQuestions = async (props: Props) => {
  const { data } = await api.patch(`/fluency-test/onboarding-questions`, {
    ...props
  })
  return data
}

export default saveOnboardingQuestions
